// eslint-disable-next-line
import { NameSpacing } from '../../../NonReact/utils/NameSpacing'

export const DIRECTORY_DETAILS = 'directoryDetails'

export enum DirectoryDetails {
    TELSYS_SERVER = 'telSysID',
    PARTITION = 'partitionID',
    TELEPHONE_NUMBER = 'telNumber',
    DESCRIPTION = 'description'
}

export const DirectoryDetailsNameSpacing: (fieldName: string) => string = (fieldName: string): string =>
    NameSpacing(DIRECTORY_DETAILS, fieldName)

export const TEL_SERVER_SCOPE_NAME: string = DirectoryDetailsNameSpacing(DirectoryDetails.TELSYS_SERVER)
export const PARTITION_SCOPE_NAME: string = DirectoryDetailsNameSpacing(DirectoryDetails.PARTITION)
export const TEL_NUMBER_SCOPE_NAME: string = DirectoryDetailsNameSpacing(DirectoryDetails.TELEPHONE_NUMBER)
export const DESCRIPTION_SCOPE_NAME: string = DirectoryDetailsNameSpacing(DirectoryDetails.DESCRIPTION)
